import { useContext, useEffect, useState } from "react";

import { UserContext } from "../context/UserContext";
import { loadAdultPersonasWithAnamnese } from "../utils/existingAnamnese";

// Por usuário. Quem já tem anamnese não deixa de ter, então o "sim" vale a sessão;
// o "não" expira rápido para a conta passar a contar assim que concluir a anamnese.
const NEGATIVE_TTL_MS = 30 * 1000;
const cache = new Map();

export function resetExistingAnamneseCache() {
  cache.clear();
  try {
    if (typeof window !== "undefined") {
      Object.keys(sessionStorage)
        .filter((k) => k.startsWith("existing_anamnese_"))
        .forEach((k) => sessionStorage.removeItem(k));
    }
  } catch {}
}

function readCache(usrId) {
  const hit = cache.get(usrId);
  if (hit && (hit.has || Date.now() - hit.at < NEGATIVE_TTL_MS)) return hit;

  try {
    if (typeof window !== "undefined") {
      const storedProfileId = localStorage.getItem("selectedProfileId");
      if (storedProfileId) {
        const entry = { has: true, at: Date.now() };
        cache.set(usrId, entry);
        return entry;
      }

      const sessionVal = sessionStorage.getItem(`existing_anamnese_${usrId}`);
      if (sessionVal !== null) {
        const parsed = JSON.parse(sessionVal);
        if (parsed && (parsed.has || Date.now() - parsed.at < NEGATIVE_TTL_MS)) {
          cache.set(usrId, parsed);
          return parsed;
        }
      }
    }
  } catch {}

  return null;
}

/**
 * Diz se a conta logada já tem alguma anamnese adulta.
 * `checking` fica true enquanto a resposta não chega; falha de rede conta como "sem anamnese"
 * (o visitante continua vendo o caminho de sempre).
 */
export default function useExistingAnamnese() {
  const { isAuthenticated, usrId } = useContext(UserContext);
  const [state, setState] = useState(() => ({ usrId: null, has: false }));

  useEffect(() => {
    if (!isAuthenticated || !usrId) return undefined;

    const hit = readCache(usrId);
    if (hit) {
      setState({ usrId, has: hit.has });
      return undefined;
    }

    let cancelled = false;
    loadAdultPersonasWithAnamnese()
      .then((items) => {
        const has = items.length > 0;
        const entry = { has, at: Date.now() };
        cache.set(usrId, entry);
        try {
          if (typeof window !== "undefined") {
            sessionStorage.setItem(`existing_anamnese_${usrId}`, JSON.stringify(entry));
          }
        } catch {}
        if (!cancelled) setState({ usrId, has });
      })
      .catch(() => {
        if (!cancelled) setState({ usrId, has: false });
      });

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, usrId]);

  if (!isAuthenticated || !usrId) return { hasAnamnese: false, checking: false };
  const resolved = state.usrId === usrId;
  return { hasAnamnese: resolved && state.has, checking: !resolved };
}
